<template>
    <div :class="['client-card', col]">
        <div class="client-card__inner">
            <div class="client-card__body">
                <div class="client-card__body-top">
                    <div class="client-card__desc">{{ desc }}</div>
                    <div class="client-card__title" v-html="title"></div>
                    <div class="client-card__text" v-if="text">{{ text }}</div>
                </div>
                <div class="client-card__body-bottom" v-if="link">
                    <a :href="link.url" class="client-card__extlink" rel="nofollow" target="_blank">{{ link.title }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientCard',
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: '',
        },
        desc: {
            type: String,
            default: '',
        },
        link: {
            type: Object,
            default: () => {},
        },
        text: {
            type: String,
            default: '',
        },
        col: {
            type: String,
            default: '',
        }
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .client-card {
        &__inner {
            background: #fff;
            height: 100%;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            border-radius: var(--br-1);
            overflow: hidden;
            padding: 32px;

            @include mobile {
                padding: 24px;
            }
        }
        &__body {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            &-bottom {
                margin-top: 76px;

                @include tablet {
                    margin-top: 42px;
                }
            }
        }
        &__title {
            font-family: var(--font-secondary);
            font-weight: 600;
            font-size: 22px;
            line-height: 28px;
            color: var(--c-gray-100);

            @include mobile {
                font-size: 18px;
            }
        }
        &__desc {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 6px;
            color: var(--c-secondary-200);
            @include mobile {
                margin-bottom: 4px;
            }
        }
        &__text {
            font-family: var(--font-secondary);
            margin-top: 72px;
            font-size: 18px;
            line-height: 28px;
            font-weight: 500;

            @include tablet {
                margin-top: 45px;
                font-size: 16px;
                line-height: 24px;
            }
            @include mobile {
                font-size: 14px;
                line-height: 20px;
                margin-top: 24px;
            }
        }
        &__extlink {
            font-size: 14px;
            font-weight: 600;
        }
    }
</style>
